$(document).ready(function() {

// ----------------------------------------------------------------------------------
// Slogan-Generator
// ----------------------------------------------------------------------------------

    if ($('.tx-kmaslogan').length > 0) {

        $('.tx-kmaslogan #generate').addClass('inactive');
        $(document).on('keyup', '#object', function (e) {
            if ($('.tx-kmaslogan #object').val() != '') {
                $('.tx-kmaslogan #generate').removeClass('inactive');
            } else {
                $('.tx-kmaslogan #generate').addClass('inactive');
            }
        });

        //if ($('form.ajaxform').length > 0) {
        $(document).on('click', 'button[type=submit]', function (e) {
            e.preventDefault();
            $('.slogans').fadeOut(300);

            var form = $('form.ajaxform.generator');

            var postString = form.serialize();

            if ($(this).val() == 'form' || $(this).val() == 'generate') {
                postString += encodeURI('&' + $(this).attr('name') + '=' + $(this).val());
            }

            $('.tx-kmaslogan').html('<div class="loading static"></div>');


            console.log(form.attr('action')+'&type=5003');


            $.ajax({
                url: form.attr('action'),
                type: 'POST',
                data: postString,

                success: function (response) {

                    setTimeout(function () {
                        $('.spinner').fadeOut(300);
                        $('.tx-kmaslogan').html(response).fadeIn(300, function () {
                            //basketButtonsUpdate();
                        });

                    }, 1000);
                },
                error: function (error) {
                    alert('Es ist ein Fehler aufgetreten.');
                }
            });
        });
    }

});